import { Button } from '@material-ui/core';
import en from '../../../../lang/en-us';
import FailureScreen from '../FailureScreen';
const { dashboard } = en;

export default function ConsolidationFoliosFailure() {
    return (
        <div className="curved-bg">
            <FailureScreen
                heading={dashboard.ConsolidationFolios.Failure.back}
                subheading={dashboard.ConsolidationFolios.Failure.subHeading}
                backLink="nct/consolidation-folios-otp"
                info1={dashboard.ConsolidationFolios.Failure.subHeadingInfo1}
                list={[
                    {
                        text: '1. Axis Liquid Direct Fund -IDCW Weekly Payout',
                    },
                    {
                        text: '2. Axis Corporate Debt Fund Direct-IDCW Payout',
                    },
                ]}
            />
        </div>
    );
}
